import { render, staticRenderFns } from "./WhatsappIncomingTariffs.vue?vue&type=template&id=8b3f5caa&"
import script from "./WhatsappIncomingTariffs.vue?vue&type=script&lang=ts&"
export * from "./WhatsappIncomingTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports